import React from 'react';
import type { CalendarViewMode } from '../calendarUtils';

export type { CalendarViewMode };

interface Props {
  value: CalendarViewMode;
  onChange: (mode: CalendarViewMode) => void;
}

export const CalendarViewModeToggle = ({ value, onChange }: Props) => (
  <div
    className="employee-attendance-calendar-page__view-toggle"
    role="tablist"
    aria-label="Calendar view mode"
  >
    <button
      type="button"
      role="tab"
      aria-selected={value === 'monthly'}
      className={`employee-attendance-calendar-page__view-toggle-btn${
        value === 'monthly'
          ? ' employee-attendance-calendar-page__view-toggle-btn--active'
          : ''
      }`}
      onClick={() => onChange('monthly')}
    >
      Monthly view
    </button>
    <button
      type="button"
      role="tab"
      aria-selected={value === 'range'}
      className={`employee-attendance-calendar-page__view-toggle-btn${
        value === 'range'
          ? ' employee-attendance-calendar-page__view-toggle-btn--active'
          : ''
      }`}
      onClick={() => onChange('range')}
    >
      Select range
    </button>
  </div>
);
